import { filter } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { Quote, PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { ShiftDigitalService } from '@sm360/widget-commons-general';

import { OPTIONS_AND_ACCESSORIES } from 'build-and-quote/constants/sections.js';
import { getSectionAdditionalClasses } from 'build-and-quote/services/SectionClassesUtils/SectionClassesUtils.js';

import OptionCategory from 'build-and-quote/components/OptionsAccessories/OptionCategory.jsx';

import 'build-and-quote/components/OptionsAccessories/OptionsAccessories.scss';

const Options = ({
    actions,
    currentSection,
    isLease,
    isOpened,
    options,
    paymentFrequencyLabel,
    quote,
    selectedFinanceTerm,
    taxCodes,
    taxesFactor,
    selectedModel,
    hasAdobeTagging,
}) => {
    const visibleOptions = filter(options, 'visible');
    const isQuoteVehicleFromInventory = quote.isQuoteVehicleFromInventory();
    React.useEffect(
        () => {
            if (isOpened) {
                ShiftDigitalService.updateDrAccessoriesShown(
                    selectedModel,
                    quote.vehicle.purchaseMethods.getSelectedPurchaseMethod()
                );
            }
        },
        [isOpened]
    );
    const optionCategories = visibleOptions.map((option) => {
        return (
            <OptionCategory
                key={option.id}
                currentSection={currentSection}
                isLease={isLease}
                isReadOnly={isQuoteVehicleFromInventory}
                selectedFinanceTerm={selectedFinanceTerm}
                paymentFrequencyLabel={paymentFrequencyLabel}
                taxesFactor={taxesFactor}
                taxCodes={taxCodes}
                optionCategory={option}
                selectOption={actions.selectOption}
                modelYear={selectedModel}
                hasAdobeTagging={hasAdobeTagging}
            />
        );
    });

    const sectionClasses = ['bloc-container', 'section-package', 'section-background'];
    const sectionAdditionalClasses = getSectionAdditionalClasses(
        sectionClasses,
        isOpened,
        currentSection,
        OPTIONS_AND_ACCESSORIES.value
    ).join(' ');
    const sectionTitle = LocaleService.t('optionsPackageSection.title.GENERAL');

    const background = `url(${ContentZonesService.getContentZone(
        'widget.build.and.buy',
        'Comfort.background.img'
    ).getValue()})`;

    return (
        <ReactCollapse isOpened={isOpened} springConfig={{ stiffness: 140, damping: 26 }}>
            <section className={sectionAdditionalClasses} style={{ backgroundImage: background }}>
                <div className="bloc-container-wrapper">
                    <div className="section-package__title">
                        <h3 className="sr-title-1 is-centered">{sectionTitle}</h3>
                    </div>
                    {optionCategories}
                </div>
            </section>
        </ReactCollapse>
    );
};

Options.propTypes = {
    actions: PropTypes.shape({
        selectOption: PropTypes.func.isRequired,
    }).isRequired,
    currentSection: PropTypes.number.isRequired,
    isLease: PropTypes.bool.isRequired,
    isOpened: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteItemCategoryModel)).isRequired,
    paymentFrequencyLabel: PropTypes.string.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    selectedFinanceTerm: PropTypes.instanceOf(PurchaseMethods.TermModel).isRequired,
    taxCodes: PropTypes.string.isRequired,
    taxesFactor: PropTypes.number.isRequired,
    hasAdobeTagging: PropTypes.bool.isRequired,
};

Options.displayName = 'Options';

export default Options;
